import React from 'react';
import { LifeBuoy, ShieldCheck, ClipboardList, Phone, Clock, ExternalLink } from 'lucide-react';
import { CONTACT, SUPPORT } from '../lyphline';

// Freeze Dryer Support hero block — machine registration + warranty claims live at
// freezedryersupport.com. Reused on the Support, Warranty and Process & Rates pages.
export const FreezeDryerSupport = ({ bg = 'bg-[#003456]', testid = 'freeze-dryer-support' }) => (
  <section className={`py-20 section-padding ${bg}`} data-testid={testid}>
    <div className="max-w-6xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-[#CE8946] font-semibold text-xs uppercase tracking-[0.2em]">
            <LifeBuoy className="h-4 w-4" /> Powered by Freeze Dryer Support
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mt-3">Register your machine &amp; file warranty claims</h2>
          <p className="text-white/70 mt-4 leading-relaxed">
            {SUPPORT.blurb} Freeze Dryer Support is our dedicated portal for machine registration,
            warranty claims and technical help — so your coverage and service history stay in one place.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a href={SUPPORT.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#CE8946] hover:bg-[#B87333] text-[#003456] font-bold px-7 py-3.5 rounded-md transition-colors" data-testid={`${testid}-register`}>
              <ShieldCheck className="h-5 w-5" /> Register your machine <ExternalLink className="h-4 w-4" />
            </a>
            <a href={SUPPORT.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border border-white/25 text-white font-semibold px-7 py-3.5 rounded-md hover:bg-white/10 transition-colors" data-testid={`${testid}-claim`}>
              <ClipboardList className="h-5 w-5" /> Submit a warranty claim <ExternalLink className="h-4 w-4" />
            </a>
          </div>
          <div className="flex flex-wrap gap-x-8 gap-y-3 mt-8 text-white/60 text-sm">
            <a href={CONTACT.phoneHref} className="inline-flex items-center gap-2 hover:text-white transition-colors"><Phone className="h-4 w-4 text-[#CE8946]" /> {CONTACT.phone}</a>
            <span className="inline-flex items-center gap-2"><Clock className="h-4 w-4 text-[#CE8946]" /> {CONTACT.hours}</span>
          </div>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
          <h3 className="text-white font-bold text-lg">What you can do at Freeze Dryer Support</h3>
          <ul className="mt-5 space-y-4">
            {[
              ['Register a new or rebuilt machine', 'Keep your serial number, model and coverage on file.'],
              ['Open a warranty claim', 'Submit your issue with photos and track its status.'],
              ['Get technical help', 'Reach the support team for troubleshooting and guidance.'],
            ].map(([t, d]) => (
              <li key={t} className="flex items-start gap-3">
                <ShieldCheck className="h-5 w-5 text-[#CE8946] mt-0.5 flex-shrink-0" />
                <div><p className="text-white font-semibold text-sm">{t}</p><p className="text-white/60 text-sm">{d}</p></div>
              </li>
            ))}
          </ul>
          <a href={SUPPORT.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#CE8946] font-semibold text-sm mt-6 hover:underline" data-testid={`${testid}-portal-link`}>
            Go to freezedryersupport.com <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default FreezeDryerSupport;
